import {
  FileOutlined,
  FilePdfOutlined,
  FilePptOutlined,
  LinkOutlined,
  PictureOutlined,
  VideoCameraOutlined,
  YoutubeFilled,
} from "@ant-design/icons";

export const setLocalStorageJSONData = (key, data) => {
  let parsedString = JSON.stringify([]);
  if (typeof data !== "undefined") {
    parsedString = JSON.stringify(data);
  }
  localStorage.setItem(key, parsedString);
};

export const getLocalStorageJSONData = (key) => {
  return JSON.parse(localStorage.getItem(key));
};

export const getInitials = (text) => {
  if (!text) return ""; // Handle empty or undefined entity names
  return text
    .split(" ") // Split the string into words
    .map((word) => word[0].toUpperCase()) // Get the first letter of each word and convert to uppercase
    .join(""); // Join the letters together
};

export const getMediaIcon = (type) => {
  switch (type) {
    case "video":
      return <VideoCameraOutlined className="me-2 file-video" />;
    case "url":
      return <LinkOutlined className="me-2 url-icon" />;
    case "image":
      return <PictureOutlined className="me-2 file-image" />;
    case "youtube":
      return <YoutubeFilled className="me-2 youtube-icon" />;
    case "pdf":
      return <FilePdfOutlined className="me-2 file-pdf" />;
    case "ppt":
      return <FilePptOutlined className="me-2 file-ppt" />;
    default:
      return <FileOutlined className="me-2 file-icon" />;
  }
};
